import React from 'react'

export default function StickerGraphic({ src, alt, height, width, x, y, rotation = 0, zindex = 1 }) {
  const style = {
    position: 'absolute',
    left: x,
    top: y,
    width,
    height,
    zIndex: zindex,
    transform: `rotate(${rotation}deg)`,
    transformOrigin: 'center',
    pointerEvents: 'none',
  }

  return <img src={src} alt={alt} height={height} width={width} aria-hidden="true" style={style} />
}
